/**
 * lang
 * 对文本进行分析&渲染
 *
 * Created by Samuel on 2022/8/15
 */
import * as _ from 'lodash-es';

import { parser } from '@core/i18n/parser';
import { tokenNormalized } from '@core/i18n/utils';

// 缓存当前语言包需要渲染的内容
const _CACHED_OBJ = new Map();
const _CACHED = new Map();
const _PURE = new Set();

export const clearLangCache = () => {
	_CACHED.clear();
	_PURE.clear();
};

export const lang = (l) => {
	function _getRenderContent(object, _props) {
		_props = _props || {};
		const { pure, ...props } = _props;
		let _res;
		if (_.isPlainObject(object)) {
			_res = {};
			_.forEach(object, (value, key) => {
				if (value) {
					_res[key] = _renderLang(value, props);
				}
			});
		} else if (_.isArray(object)) {
			const _obj = _.filter(object),
				_objLength = _obj.length;
			_res = _.reduce(
				_obj,
				(r, value, idx) => {
					r = r.concat(_renderLang(value, { ...props, key: 'c' + idx }));
					// 支持传入 pure，避免生成的string中生成换行符相关内容
					if (idx + 1 < _objLength && !pure) {
						r.push(<br key={'br' + idx} />);
					}
					return r;
				},
				[],
			);
		}

		return _res;
	}

	function _renderLang(name, props = null) {
		if (!l) {
			return null;
		}
		// name 需要进行 normalize xxx.xx.xx like this
		const normalName = tokenNormalized(name);

		const raw = _.get(l, normalName);
		const isPlainStructure = _.isPlainObject(raw) || _.isArray(raw);

		// 增加 _CACHED-object 将 数组和对象的复杂类型都在 _CACHED-object 中缓存
		// 如果命中则表明需要返回复杂数据结构（类似于一个递归获取的流程）
		if (isPlainStructure) {
			let _objKeys;
			if (_CACHED_OBJ.has(normalName)) {
				_objKeys = _CACHED_OBJ.get(normalName);
			} else {
				// 生成相关 obj keys
				// 进行objKeys缓存
				if (_.isPlainObject(raw)) {
					_objKeys = {};
					_.forEach(raw, (value, key) => {
						_objKeys[key] = `${normalName}.${key}`;
					});
				} else if (_.isArray(raw)) {
					_objKeys = _.map(raw, (v, idx) => `${normalName}.${idx}`);
				}
				_CACHED_OBJ.set(normalName, _objKeys);
			}

			return _getRenderContent(_objKeys, props);
		}

		if (_PURE.has(normalName)) {
			return _.get(l, normalName);
		}

		if (_CACHED.has(normalName)) {
			const Cp = _CACHED.get(normalName);
			return <Cp {...props} />;
		}
		const [Cp, needCache] = parser(_.get(l, normalName), normalName);

		if (needCache) {
			_CACHED.set(normalName, Cp);
			return <Cp {...props} />;
		} else {
			_PURE.add(normalName);
			return Cp;
		}
	}

	return _renderLang;
};
